<template>
  <div class="bg-white shadow-sm rounded-lg overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full bg-white border border-gray-300">
        <thead class="bg-gray-100">
          <tr class="text-left border-b border-gray-300">
            <th class="px-4 py-3">Folio</th>
            <th class="px-4 py-3">Producto</th>
            <th class="px-4 py-3">Cantidad Total</th>
            <th class="px-4 py-3">Precio</th>
            <th class="px-4 py-3">Total de Descuento</th>
            <th class="px-4 py-3">Total de Rechazo</th>
            <th class="px-4 py-3">Total Vendido</th>
            <th class="px-4 py-3">Factura Requerida</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="item in data" 
            :key="item.product_id" 
            class="border-b border-gray-300 hover:bg-gray-50"
          >
            <td class="px-4 py-3">{{ item.all_folios }}</td>
            <td class="px-4 py-3">{{ item.product_name }}</td>
            <!--    AMOUNT      -->
            <td class="px-4 py-3">
              {{ 
                parseInt(item.total_amount) - (
                  (parseInt(item.total_rejection_boxes) + parseInt(item.total_rejection_pieces))>item.total_amount?
                    parseInt(item.total_amount): 
                    parseInt(item.total_rejection_boxes + item.total_rejection_pieces)
                ) - (parseInt(item.discounts)-parseInt(item.promotions))
              }}
              <div v-if="item.discounts>0">
                <br /><br>
                {{ parseInt(item.discounts) - parseInt(item.promotions) }}
              </div>
              <div v-if="item.total_rejection_boxes>0 || item.total_rejection_pieces>0">
                <br><br>
                {{ 
                  (parseInt(item.total_rejection_boxes) + parseInt(item.total_rejection_pieces))>item.total_amount?
                    parseInt(item.total_amount): 
                    parseInt(item.total_rejection_boxes + item.total_rejection_pieces)
                }}
              </div>
            </td>
            <!--    PRICE      -->
            <td class="px-4 py-3">
              {{ formatCurrency(item.price) }}
              <div v-if="item.discounts>0">
                <br /><br>
                {{ formatCurrency(item.total_discount) }}
              </div>
              <div v-if="item.total_rejection_boxes>0 || item.total_rejection_pieces>0">
                <br><br>
                {{ formatCurrency(item.price) }}
              </div>
            </td>
            <!--    DISCOUNT      -->
            <td class="px-4 py-3">
              {{ formatCurrency(0) }}
              <div v-if="item.discounts>0">
                <br /><br>
                {{ formatCurrency(item.total_discount) }}
              </div>
              <div class="text-red-500" v-if="item.total_rejection_boxes>0 || item.total_rejection_pieces>0">
                <br><br>
                {{ 
                  formatCurrency(
                    parseFloat(item.price)*(
                      (parseInt(item.total_rejection_boxes) + parseInt(item.total_rejection_pieces))>item.total_amount?
                        parseInt(item.total_amount): 
                        parseInt(item.total_rejection_boxes + item.total_rejection_pieces)
                    )
                  )
                }}
              </div>
            </td>
            <!--    REJECTIONS      -->
            <td class="px-4 py-3">
              {{ 0 }}
              <div v-if="item.discounts>0">
                <br /><br>
                {{ 0 }}
              </div>
              <div v-if="item.total_rejection_boxes>0 || item.total_rejection_pieces>0" class="text-red-500">
                <br><br>
                {{ 
                  (parseInt(item.total_rejection_boxes) + parseInt(item.total_rejection_pieces))>item.total_amount?
                    parseInt(item.total_amount): 
                    parseInt(item.total_rejection_boxes + item.total_rejection_pieces)
                }}
              </div>
            </td>
            <!--    TOTOAL SALES      -->
            <td class="px-4 py-3 font-semibold">
              {{ formatCurrency(item.total_sales-item.total_discount) }}
              <div v-if="item.discounts>0">
                <br /><br>
                {{ formatCurrency(item.total_discount) }}
              </div>
              <div v-if="item.total_rejection_boxes>0 || item.total_rejection_pieces>0">
                <br><br>
                {{ 0 }}
              </div>
            </td>
            <!--    INVOICE      -->
            <td class="px-4 py-3">{{ item.invoice_required }}</td>
          </tr>
          <tr v-if="!data || data.length === 0">
            <td colspan="8" class="text-center px-4 py-3 text-gray-500">
              {{ emptyMessage }}
            </td>
          </tr>
        </tbody>
        <tfoot v-if="data!=null && data.length>0">
          <tr>
            <td class="py-3 text-end" colspan="2">Total:</td>
            <td class="px-4">
              {{ 
                data.map((item) => parseInt(item.total_amount)).reduce( (acc,curr)=> acc + curr,0) -
                  data.map((item)=>(parseInt(item.total_rejection_boxes || 0) + parseInt(item.total_rejection_pieces || 0))>item.total_amount?item.total_amount:parseInt(item.total_rejection_boxes || 0) + parseInt(item.total_rejection_pieces || 0) ).reduce((acc,curr)=> acc + curr,0)
              }}
            </td>
            <td></td>
            <td class="px-4">
              {{ formatCurrency(data.map((item)=>item.total_discount).reduce( (acc,curr)=> acc + curr,0 )) }}
            </td>
            <td class="px-4 text-red-500">{{ data.map((item)=>(parseInt(item.total_rejection_boxes || 0) + parseInt(item.total_rejection_pieces || 0))>item.total_amount?item.total_amount:parseInt(item.total_rejection_boxes || 0) + parseInt(item.total_rejection_pieces || 0) ).reduce((acc,curr)=> acc + curr,0) }}</td>
            <td class="px-4">
              {{ formatCurrency(
                data.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
              ) }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Tabla de Reporte',
    },
    emptyMessage: {
      type: String,
      default: 'No hay datos disponibles',
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0)
    },
  },
}
</script>